module.exports = __webpack_public_path__ + "static/media/034.062c9fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/034.jpg
// module id = 507
// module chunks = 0